document.addEventListener('DOMContentLoaded', function () {
  const chemPage=document.querySelector('.cpp-chemical-page');
  if (!chemPage) return;

  const content=chemPage.querySelector('.cpp-page__content');
  const table=content && content.querySelector('table');
  if (!content || !table) return;

  /* Remove the Formful/app section that follows this page content on the development theme. */
  const mainSection=chemPage.closest('.shopify-section');
  if (mainSection) {
    const nextSection=mainSection.nextElementSibling;
    if (nextSection && nextSection.querySelector('form, input, textarea, select, [class*="formful"], [id*="form_"]')) {
      nextSection.style.display='none';
    }
  }

  const aliases={
    'acetic acid':'Vinegar / ethanoic acid',
    'acetone':'Propanone',
    'ammonium hydroxide':'Ammonia solution / aqueous ammonia',
    'butyl alcohol':'Butanol',
    'calcium chloride':'De-icer / brine salt / road salt solution',
    'citric acid':'Citric acid / descaling acid',
    'diesel oil':'Diesel / gas oil / DERV / red diesel',
    'dimethyl formamide':'DMF',
    'ethyl alcohol':'Ethanol / ethyl alcohol / grain alcohol / industrial alcohol',
    'ethylene glycol':'Antifreeze / coolant / MEG / monoethylene glycol',
    'formic acid':'Methanoic acid',
    'glycerol':'Glycerine / glycerin',
    'hydrochloric acid':'Muriatic acid / spirits of salt',
    'hydrogen peroxide':'Peroxide / H2O2',
    'iso-propyl alcohol':'IPA / isopropanol / rubbing alcohol / propan-2-ol',
    'methyl alcohol':'Methanol / wood alcohol / methyl hydrate',
    'methyl ethyl ketone':'MEK / butanone / 2-butanone',
    'methylene dichloride':'Dichloromethane / DCM / methylene chloride / methylene dichloride',
    'nitric acid':'Aqua fortis',
    'paraffin oil':'Mineral oil / liquid paraffin / white oil',
    'perchlorethylene':'Perchloroethylene / PCE / PERC / tetrachloroethylene',
    'petrol':'Gasoline / petrol / motor spirit',
    'phosphoric acid':'Orthophosphoric acid',
    'potassium hydroxide':'Caustic potash',
    'sodium carbonate':'Soda ash / washing soda',
    'sodium chloride':'Salt / brine',
    'sodium hydroxide':'Caustic soda / lye',
    'sodium hypochlorite':'Bleach / chlorine bleach / hypo / liquid chlorine / Javel water',
    'sulphuric acid':'Sulfuric acid / battery acid',
    'sulfuric acid':'Sulphuric acid / battery acid',
    'trichloroethylene':'Trichloroethylene / TCE / trike',
    'water (sea)':'Seawater / salt water',
    'white spirit':'Mineral spirits / Stoddard solvent',
    'vegetable oils':'Plant oils'
  };

  const extra=[
    ['Urea solution (32.5%)','AdBlue® / DEF / AUS 32 / ARLA 32','1','—','—','—','—','1'],
    ['Calcium hypochlorite solution','Pool chlorine / dry chlorine / bleaching agent','1','—','—','—','—','1'],
    ['Potassium hypochlorite solution','Liquid bleaching agent','1','—','—','—','—','—'],
    ['Soap / detergent solution','Detergent / wash solution','1','—','—','—','—','1'],
    ['Sodium bisulphite solution','Sodium bisulfite / reducing agent','1','—','—','—','—','1'],
    ['Brine','Salt water / sodium chloride solution','1','1','—','—','—','1'],

    ['Ammonium nitrate solution','AN solution / fertiliser solution','—','—','—','—','—','—'],
    ['Ammonium phosphate solution','Fertiliser solution / phosphate fertiliser','—','—','—','—','—','—'],
    ['Calcium nitrate solution','Liquid fertiliser / calcium nitrate','—','—','—','—','—','—'],
    ['Calcium hydroxide solution','Lime water / hydrated lime solution','—','—','—','—','—','—'],
    ['Calcium carbonate slurry','Limestone slurry / chalk slurry','—','—','—','—','—','—'],
    ['Potassium carbonate solution','Potash solution / potassium carbonate','—','—','—','—','—','—'],
    ['Potassium chloride solution','Potash fertiliser / KCl solution','—','—','—','—','—','—'],
    ['Potassium nitrate solution','Saltpetre solution / fertiliser solution','—','—','—','—','—','—'],
    ['Sodium bicarbonate solution','Bicarbonate of soda / baking soda solution','—','—','—','—','—','—'],
    ['Sodium bisulphate solution','Sodium bisulfate / dry acid solution','—','—','—','—','—','—'],
    ['Sodium metabisulphite solution','Sodium metabisulfite / SMBS / metabisulphite','—','—','—','—','—','—'],
    ['Sodium sulphite solution','Sodium sulfite / reducing agent','—','—','—','—','—','—'],
    ['Sodium sulphate solution','Sodium sulfate solution','—','—','—','—','—','—'],
    ['Sodium thiosulphate solution','Sodium thiosulfate / dechlorinator','—','—','—','—','—','—'],
    ['Sodium silicate solution','Water glass / liquid glass / soluble glass','—','—','—','—','—','—'],
    ['Trisodium phosphate solution','TSP / trisodium phosphate / sodium phosphate tribasic','—','—','—','—','—','—'],
    ['Sodium aluminate solution','Aluminate solution / water-treatment chemical','—','—','—','—','—','—'],
    ['Sodium chlorite solution','Chlorite solution / chlorine dioxide precursor','—','—','—','—','—','—'],
    ['Sodium chlorate solution','Chlorate solution','—','—','—','—','—','—'],
    ['Peracetic acid solution','PAA / peroxyacetic acid / peracetic acid sanitiser','—','—','—','—','—','—'],
    ['Propylene glycol','PG / MPG / monopropylene glycol / glycol / antifreeze fluid','—','—','—','—','—','—'],
    ['Propylene glycol / water mix','PG coolant / glycol coolant','—','—','—','—','—','—'],
    ['Kerosene','Paraffin / heating oil / kerosene / jet fuel family','—','—','—','—','—','—'],
    ['Biodiesel (B100)','B100 / FAME / fatty acid methyl ester biodiesel','—','—','—','—','—','—'],
    ['HVO renewable diesel','HVO / renewable diesel / hydrotreated vegetable oil','—','—','—','—','—','—'],
    ['Urea ammonium nitrate solution (UAN)','UAN 28 / UAN 30 / UAN 32 / liquid fertiliser','—','—','—','—','—','—'],
    ['Ferric sulphate solution','Ferric sulfate / water-treatment coagulant','—','—','—','—','—','—'],
    ['Ferrous sulphate solution','Ferrous sulfate / iron sulfate','—','—','—','—','—','—'],
    ['Polyaluminium chloride (PAC)','PAC / polyaluminum chloride / water-treatment coagulant','—','—','—','—','—','—'],
    ['Deionised water','DI water / demineralised water','—','—','—','—','—','—'],
    ['Potable water','Drinking water / mains water','—','—','—','—','—','—'],
    ['Chlorinated water','Chlorine-treated water / pool water','—','—','—','—','—','—'],
    ['Hydraulic oil','Hydraulic fluid / mineral hydraulic oil / HLP oil','—','—','—','—','—','—'],
    ['Brake fluid (glycol ether based)','DOT 3 / DOT 4 / glycol ether brake fluid','—','—','—','—','—','—'],
    ['Mineral oil','White mineral oil / technical mineral oil','—','—','—','—','—','—'],
    ['Paraffin wax','Paraffin wax / hydrocarbon wax','—','—','—','—','—','—'],
    ['Sodium percarbonate solution','Oxygen bleach / sodium percarbonate','—','—','—','—','—','—']
  ];

  const ratingOverrides={
    'Potassium hypochlorite solution':['X','—','X','X','1','—'],
    'Sodium metabisulphite solution':['1','—','—','—','—','—'],
    'Sodium chlorite solution':['2','—','—','—','X','—'],
    'Peracetic acid solution':['2','—','2','—','X','—'],
    'Propylene glycol / water mix':['1','1','1','—','1','—'],
    'Biodiesel (B100)':['X','2','1','1','X','—'],
    'HVO renewable diesel':['—','—','1','1','1','—'],
    'Urea ammonium nitrate solution (UAN)':['1','2','1','—','—','—'],
    'Polyaluminium chloride (PAC)':['1','—','X','X','—','—'],
    'Sodium percarbonate solution':['1','—','—','—','X','—'],
    'Urea solution (32.5%)':['1','—','1','1','1','1'],
    'Calcium hypochlorite solution':['1','—','1','X','2','1'],
    'Soap / detergent solution':['1','—','1','X','1','1'],
    'Brine':['1','—','1','—','1','—'],
    'Ammonium nitrate solution':['1','—','1','1','1','1'],
    'Ammonium phosphate solution':['1','—','1','1','1','1'],
    'Calcium nitrate solution':['1','—','2','1','1','1'],
    'Calcium hydroxide solution':['1','—','1','—','—','—'],
    'Calcium carbonate slurry':['1','—','1','X','1','1'],
    'Potassium carbonate solution':['1','—','1','X','1','1'],
    'Potassium chloride solution':['1','—','2','X','1','1'],
    'Potassium nitrate solution':['1','—','1','1','1','1'],
    'Sodium bicarbonate solution':['1','—','1','X','1','1'],
    'Sodium bisulphate solution':['1','—','X','X','1','1'],
    'Sodium bisulphite solution':['1','—','2','X','2','1'],
    'Sodium sulphite solution':['1','—','X','X','1','1'],
    'Sodium sulphate solution':['1','—','1','1','1','1'],
    'Sodium thiosulphate solution':['1','—','1','X','1','1'],
    'Sodium silicate solution':['1','—','1','2','1','1'],
    'Trisodium phosphate solution':['1','—','1','X','1','1'],
    'Sodium aluminate solution':['1','—','1','2','1','1'],
    'Sodium chlorate solution':['1','—','1','2','1','1'],
    'Propylene glycol':['1','—','1','1','1','1'],
    'Kerosene':['X','—','1','1','1','X'],
    'Ferric sulphate solution':['1','—','1','X','1','1'],
    'Ferrous sulphate solution':['1','—','1','X','1','1'],
    'Deionised water':['1','—','1','1','1','—'],
    'Potable water':['1','—','1','1','1','1'],
    'Chlorinated water':['2','—','1','X','2','X'],
    'Hydraulic oil':['X','—','1','1','1','—'],
    'Brake fluid (glycol ether based)':['X','—','1','1','X','1'],
    'Mineral oil':['2','—','1','1','1','X'],
    'Paraffin wax':['1','—','1','1','1','1']
  };

  const nameFixes={
    'Acetaldenyde':'Acetaldehyde',
    'Acetic anhydrid':'Acetic anhydride',
    'Ammonium sulhate (50%)':'Ammonium sulphate (50%)',
    'Buty acetate':'Butyl acetate',
    'Carbon tetrachlorode':'Carbon tetrachloride',
    'Chloracetic acid':'Chloroacetic acid',
    'Chorosulphonic acid':'Chlorosulphonic acid',
    'Codliver oil':'Cod liver oil',
    'Diethylether':'Diethyl ether',
    'Ethylacetate':'Ethyl acetate',
    'Hydrofluric acid (40%)':'Hydrofluoric acid (40%)',
    'Nickechloride':'Nickel chloride',
    'Silcone fluids':'Silicone fluids',
    'Sulphric acid (fuming)':'Sulphuric acid (fuming)',
    'Tetrachloethane':'Tetrachloroethane',
    'Tetrahydrofurane':'Tetrahydrofuran',
    'Tetrlin':'Tetralin',
    'Titaniun tetrachloride':'Titanium tetrachloride',
    'Trichoracetic acid':'Trichloroacetic acid',
    'Trichlorethane':'Trichloroethane',
    'Trichlorethylene':'Trichloroethylene',
    'Troethanolamine':'Triethanolamine',
    'Triethyamine':'Triethylamine'
  };

  const body=table.tBodies[0] || table;
  const first=body.rows[0];
  if (!first) return;

  /* Avoid duplicating enhancements if Shopify reloads a section in the editor. */
  if (!first.querySelector('.cpp-chem-common-head')) {
    const common=document.createElement('td');
    common.className='cpp-chem-common-head';
    common.innerHTML='<strong>Common / trade / search names</strong>';
    first.insertBefore(common, first.cells[1]);

    Array.from(body.rows).slice(1).forEach(function(row){
      const rawName=(row.cells[0] ? row.cells[0].textContent : '').trim();
      if (nameFixes[rawName] && row.cells[0]) {
        row.cells[0].innerHTML='<strong>'+nameFixes[rawName]+'</strong>';
      }
      const n=(row.cells[0] ? row.cells[0].textContent : '').trim().toLowerCase();
      let a='';
      Object.keys(aliases).forEach(function(k){ if(n.includes(k)) a=aliases[k]; });
      const c=document.createElement('td');
      c.className='cpp-chem-alias';
      c.textContent=a;
      row.insertBefore(c,row.cells[1]);
    });

    extra.forEach(function(x){
      const tr=document.createElement('tr');
      const ratings=ratingOverrides[x[0]] || x.slice(2);
      const values=[x[0],x[1]].concat(ratings);
      values.forEach(function(v,i){
        const td=document.createElement('td');
        if(i===0) td.innerHTML='<strong>'+v+'</strong>';
        else td.textContent=v;
        tr.appendChild(td);
      });
      tr.dataset.added='true';
      body.appendChild(tr);
    });

    Array.from(body.rows).slice(1)
      .sort(function(a,b){
        return (a.cells[0]?.textContent||'').localeCompare((b.cells[0]?.textContent||''),undefined,{sensitivity:'base'});
      })
      .forEach(function(row){ body.appendChild(row); });
  }

  /* Hide only the old introductory copy, not the wrapper containing the chart. */
  const oldHeader=content.querySelector('.page-header');
  if (oldHeader) oldHeader.style.display='none';

  const article=table.closest('[itemprop="articleBody"]') || table.parentElement;
  if (article) {
    Array.from(article.children).forEach(function(el){
      if (el !== table && !el.classList.contains('cpp-chem-guide') && !el.classList.contains('cpp-chem-materials-float') && !el.classList.contains('cpp-chem-table-wrap')) {
        el.style.display='none';
      }
    });
  }

  if (!content.querySelector('.cpp-chem-guide')) {
    const panel=document.createElement('div');
    panel.className='cpp-chem-guide';
    panel.innerHTML='<span class="cpp-chem-kicker">CPP® MATERIAL COMPATIBILITY GUIDE</span><h2>Find a chemical or common product name</h2><p>Search by chemical name, common name or recognised trade/industry term such as <b>bleach</b>, <b>caustic soda</b>, <b>AdBlue / DEF</b>, <b>antifreeze</b>, <b>IPA</b> or <b>petrol</b>.</p><div class="cpp-chem-search"><input type="search" id="CppChemSearch" placeholder="Search chemical or common name…" autocomplete="off"><button type="button" id="CppChemClear">Clear</button></div><div class="cpp-chem-legend"><span><b class="r1">1</b> Recommended</span><span><b class="r2">2</b> Moderate / slight attack</span><span><b class="rx">X</b> Not recommended</span><span><b class="ru">—</b> Check grade / concentration</span></div><div class="cpp-chem-material"><strong>TPE/P.P</strong> = Thermoplastic Elastomer / Polypropylene — CPP standard seal, gasket &amp; O-ring material.</div><p class="cpp-chem-note"><strong>Trade-name note:</strong> Trade and industry names are included as search aids only. Branded products can contain additives or different concentrations, so confirm the product formulation before relying on a material rating.</p><p class="cpp-chem-note"><strong>Rating note:</strong> Where supplementary compatibility data has been added, excellent/good ratings are shown as <strong>1</strong>, fair/conditional ratings as <strong>2</strong>, and not recommended as <strong>X</strong>. A dash means the rating is concentration-, grade- or formulation-dependent, or that a direct rating has not been verified.</p><p class="cpp-chem-note"><strong>Formulated products:</strong> Variable mixtures such as general NPK fertilisers and broad solvent families are not given a single rating; check the exact formulation.</p><p class="cpp-chem-note"><strong>Important:</strong> Compatibility depends on concentration, temperature, pressure, exposure time, mixtures and mechanical stress. Ratings are material guidance only; final suitability should be confirmed under actual service conditions.</p><div class="cpp-chem-count" aria-live="polite"></div>';
    table.parentNode.insertBefore(panel,table);
  }

  if (!content.querySelector('.cpp-chem-materials-float')) {
    const materials=document.createElement('div');
    materials.className='cpp-chem-materials-float';
    materials.setAttribute('aria-label','Chemical resistance table column headings');
    const heads=Array.from(first.cells).map(function(cell){ return (cell.textContent||'').trim(); });
    const track=document.createElement('div');
    track.className='cpp-chem-materials-float__track';
    heads.forEach(function(heading,index){
      const cell=document.createElement('span');
      cell.className='cpp-chem-float-cell cpp-chem-float-cell--'+(index+1);
      cell.textContent=heading;
      track.appendChild(cell);
    });
    materials.appendChild(track);
    table.parentNode.insertBefore(materials,table);
  }

  if (!table.parentElement.classList.contains('cpp-chem-table-wrap')) {
    const wrap=document.createElement('div');
    wrap.className='cpp-chem-table-wrap';
    table.parentNode.insertBefore(wrap,table);
    wrap.appendChild(table);
  }

  const tableWrap=table.parentElement;
  const floatBar=content.querySelector('.cpp-chem-materials-float');
  const floatTrack=floatBar && floatBar.querySelector('.cpp-chem-materials-float__track');
  function syncFloat(){
    if (!floatTrack || !tableWrap) return;
    floatTrack.style.transform='translateX(' + (-tableWrap.scrollLeft) + 'px)';
  }
  if (tableWrap && floatTrack) {
    tableWrap.addEventListener('scroll',syncFloat,{passive:true});
    syncFloat();
  }

  const panel=content.querySelector('.cpp-chem-guide');
  const rows=Array.from(body.rows).slice(1);
  const count=panel.querySelector('.cpp-chem-count');
  const input=panel.querySelector('#CppChemSearch');

  function paint(){
    let shown=0;
    const q=input.value.trim().toLowerCase();
    rows.forEach(function(r){
      const hit=!q || r.textContent.toLowerCase().includes(q);
      r.hidden=!hit;
      if(hit) shown++;
      Array.from(r.cells).slice(2).forEach(function(c){
        const t=c.textContent.trim();
        c.classList.remove('rating-1','rating-2','rating-x');
        if(t==='1') c.classList.add('rating-1');
        if(t==='2') c.classList.add('rating-2');
        if(t==='X') c.classList.add('rating-x');
      });
    });
    count.textContent=shown+' chemical entr'+(shown===1?'y':'ies')+' shown';
  }

  input.addEventListener('input',paint);
  panel.querySelector('#CppChemClear').addEventListener('click',function(){
    input.value='';
    paint();
    input.focus();
  });
  paint();
});

(() => {
  let revision = 0;

  function showCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('.cpp-cart-count').forEach((element) => {
      const value = String(count);
      if (element.textContent !== value) element.textContent = value;
    });
  }

  async function refreshCount(event) {
    const currentRevision = ++revision;
    const count = event?.cartData?.item_count;
    if (Number.isInteger(count)) {
      showCount(count);
      return;
    }
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (currentRevision === revision) showCount(cart.item_count);
    } catch (_) {}
  }

  function init() {
    document.querySelectorAll('.cpp-cart-count').forEach((element) => {
      element.setAttribute('aria-live', 'polite');
      element.setAttribute('aria-atomic', 'true');
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
    }
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) refreshCount();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
